import { useLanguage } from '../../i18n';

interface DragOverlayProps {
  isDragging: boolean;
}

function DragOverlay({ isDragging }: DragOverlayProps) {
  const { lang } = useLanguage();

  if (!isDragging) return null;

  return (
    <div className="fixed inset-0 z-40 bg-black/70 flex items-center justify-center backdrop-blur-sm">
      <div className="bg-terminal-card border-2 border-dashed border-status-go rounded-2xl p-12 text-center max-w-md mx-4 animate-pulse">
        <div className="text-6xl mb-4">📁</div>
        <div className="text-xl text-terminal-text font-medium mb-2">
          {lang === 'ko' ? '파일을 여기에 놓으세요' : 'Drop files here'}
        </div>
        <div className="text-terminal-muted text-sm space-y-1">
          <div className="flex items-center justify-center gap-2">
            <span>🖼️</span>
            <span>
              {lang === 'ko' ? '이미지/PDF → 기획 의도' : 'Images/PDF → Planning'}
            </span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <span>📊</span>
            <span>
              {lang === 'ko' ? 'CSV/JSON → 테스트 케이스' : 'CSV/JSON → Test Cases'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DragOverlay;

